
export default function vernissages(): any[] {
    return [
        {
            floats:{
                text: {
                    "position": {
                        "top" : 0,
                        "left": 0,
                        "width": 900,
                        "height": 150,
                        "opacity": 1,
                        "rotate": 0
                    },
                },
                order: {
                    "position": {
                        "top" : 145,
                        "left": 125,
                        "width": 150,
                        "height": 150
                    },
                },
                cover: {
                    "position": {
                        "top" : 145,
                        "left": 300,
                        "width": 350,
                        "height": 625
                    },
                },
                coverTitle: {
                    "position": {
                        "top": 537,
                        "left": 5,
                        "width": 220,
                        "height": 33,
                        "opacity": 1,
                        "rotate": 0
                    },
                },
                coverTitle2: {
                    "position": {
                        "top": 500,
                        "left": 5,
                        "width": 220,
                        "height": 33,
                        "opacity": 1,
                        "rotate": 0
                    },
                },
                image0:{
                    "position": {
                        "top" : 145,
                        "left": 670, 
                        "width": 230,
                        "height": 230
                    },
                },
                image1:{
                    "position": {
                        "top" : 395,
                        "left": 670, 
                        "width": 230,
                        "height": 230 
                    },
                },
                image2:{
                    "position": {
                        "top" : 645,
                        "left": 670, 
                        "width": 125,
                        "height": 125
                    },
                },
                image3:{
                    "position": {
                        "top" : 315,
                        "left": 0, 
                        "width": 280,
                        "height": 280
                    },
                },
                image4:{
                    "position": {
                        "top" : 615,
                        "left": 60, 
                        "width": 220,
                        "height": 375 
                    },
                },
                image5:{
                    "position": {
                        "top" : 790,
                        "left": 300,
                        "width": 350,
                        "height": 200 
                    },
                }, 
                imageStyle: {
                    "border": "5px solid var(--force-contast-color)",
                    "backgroundColor": "#508750",
                    "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                }, 
                "imageBorder": {
                    "borderWidth": 5,
                    "borderStyle": "dashed",
                    "borderColor": "var(--force-contast-color)"
                } ,
            },
            height: 1010,
        },
        {
            floats:{
                text: {
                    "position": {
                        "top" : 605,
                        "left": 0, 
                        "width": 380,
                        "height": 240,
                        "opacity": 0,
                        "rotate": 0
                    }
                },
                order:{
                    "position": {
                        "top" : 0,
                        "left": 630, 
                        "width": 130,
                        "height": 130
                    }
                },
                cover: {
                    "position": {
                        "top" : 0,
                        "left": 0, 
                        "width": 380,
                        "height": 585
                    }
                },
                coverTitle: {
                    "position": {
                        "top" : 547,
                        "width": 220,
                        "left": 5, 
                        "height": 33
                    }
                },
                coverTitle2: {
                    "position": {
                        "top" : 505, 
                        "width": 220, 
                        "left": 5, 
                        "height": 33 
                    }
                },
                image0: {
                    "position": {
                        "top" : 0,
                        "left": 400, 
                        "width": 210,
                        "height": 295
                    },
                },
                image1: {
                    "position": {
                        "top" : 150,
                        "left": 630, 
                        "width": 270,
                        "height": 270
                    }, 
                },
                image2: {
                    "position": {
                        "top" : 315,
                        "left": 400, 
                        "width": 210,
                        "height": 210
                    },
                },
                image3: {
                    "position": {
                        "top" : 440,
                        "left": 630, 
                        "width": 270,
                        "height": 270
                    },  
                },
                image4: {
                    "position": {
                        "top" : 545,
                        "left": 400, 
                        "width": 210,
                        "height": 210
                    },
                },
                image5: {
                    "position": {
                        "top" : 730,
                        "left": 630, 
                        "width": 140,
                        "height": 140
                    },
                },
                imageStyle: {
                    "border": "5px solid var(--force-contast-color)",
                    "backgroundColor": "#508750",
                    "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                }, 
                "imageBorder": {
                    "borderWidth": 5,
                    "borderStyle": "dashed",
                    "borderColor": "var(--force-contast-color)"
                }
            },
            height: 890,
        },
        {
            floats:{
                text: {
                    "position": {
                        "top" : 0,
                        "left": 0,
                        "width": 550,
                        "height": 230,
                        "opacity": 1,
                        "rotate": 0
                    }
                },
                order:{
                "position": {
                        "top" : 255,
                        "left": 0,
                        "width": 150,
                        "height": 150
                    } 
                },
                cover: {
                    "position": {
                        "top" : 0,
                        "left": 565,  
                        "width": 335,
                        "height": 555,
                        "opacity": 1,
                        "rotate": 0
                    },
                },
                coverTitle: {
                    "position": {
                        "top": 567,
                        "left": 5,
                        "width": 200,
                        "height": 33,
                        "opacity": 1,
                        "rotate": 0
                    }
                },
                coverTitle2: {
                    "position": {
                        "top": 530,
                        "left": 5,
                        "width": 200,
                        "height": 33,
                        "opacity": 1,
                        "rotate": 0
                    } 
                },
                image0: {
                    "position": {
                        "top" : 255,
                        "left": 170,
                        "width": 150,
                        "height": 150
                    } 
                },
                image1: {
                    "position": {
                        "top" : 425,
                        "left": 0,
                        "width": 320,
                        "height": 275
                    } 
                },
                image2: {
                    "position": {
                        "top" : 255,
                        "left": 340,
                        "width": 205,
                        "height": 300
                    } 
                },
                image3: {
                    "position": {
                        "top" : 720,
                        "left": 170,
                        "width": 150,
                        "height": 150
                        
                    }
                },
                image4: {
                    "position": {
                        "top" : 575,
                        "left": 340,
                        "width": 205,
                        "height": 295
                    } 
                },
                image5: {
                    "position": {
                        "top" : 575,
                        "left": 565,
                        "width": 180,
                        "height": 180
                    } 
                },
                imageStyle: {
                    "border": "5px solid var(--force-contast-color)",
                    "backgroundColor": "#508750",
                    "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                }, 
                "imageBorder": {
                    "borderWidth": 5,
                    "borderStyle": "dashed",
                    "borderColor": "var(--force-contast-color)"
                }
            },
            height: 940,
        },
        {
            floats:{
                text: {
                    "position": {
                        "top" : 605,
                        "left": 265, 
                        "width": 360,
                        "height": 265,
                        "opacity": 0,
                        "rotate": 0
                    },
                },
                order:{
                    "position": {
                        "top" : 45,
                        "left": 640, 
                        "width": 120,
                        "height": 120
                    }
                },
                cover: {
                    "position": {
                        "top" : 0,
                        "left": 265, 
                        "width": 360,
                        "height": 585
                    }
                },
                coverTitle: {
                    "position": {
                        "top" : 547,
                        "width": 220,
                        "left": 5, 
                        "height": 33
                    }
                },
                coverTitle2: {
                    "position": {
                        "top" : 505, 
                        "width": 220, 
                        "left": 5, 
                        "height": 33 
                    }
                },
                image0: {
                    "position": {
                        "top" : 0,
                        "left": 0, 
                        "width": 250,
                        "height": 250
                    }, 
                },
                image1: {
                    "position": {
                        "top" : 270,
                        "left": 0, 
                        "width": 250,
                        "height": 250
                    },
                },
                image2: {
                    "position": {
                        "top" : 540,
                        "left": 70, 
                        "width": 180,
                        "height": 180
                    },
                },
                image3: {
                    "position": {
                        "top" : 600,
                        "left": 640, 
                        "width": 130,
                        "height": 270
                    }, 
                },
                image4: {
                    "position": {
                        "top" : 180,
                        "left": 640, 
                        "width": 260,
                        "height": 260
                    }, 
                },
                image5: {
                    "position": {
                        "top" : 455,
                        "left": 640, 
                        "width": 130,
                        "height": 130
                    }, 
                },
                imageStyle: { 
                    "backgroundColor": "#508750",
                    "boxShadow": "0 13px 22px 0 #00000066, 0 2px 5px #000000EE"
                }, 
                "imageBorder": {
                    "borderWidth": 5,
                    "borderStyle": "dashed",
                    "borderColor": "var(--force-contast-color)"
                }
            },
            height: 920,
        },
    ]
}